<template>
  <div class="option-info-container">
    <div class="option-header">
      <div class="input-title">옵션정보</div>
      <button type="button" class="option-edit-btn" @click="orderModalOpen = true">옵션 수정하기</button>
    </div>
    <div class="option-border"></div>
    <div class="option-row">
      <div :style="{ flex: 1 }">
        <div class="info-title">요구 응답수</div>
        <div class="info-content">{{ this.headCount }}</div>
      </div>
      <div :style="{ flex: 1 }">
        <div class="info-title">소요시간</div>
        <div class="info-content">{{ this.spendTime }}</div>
      </div>
      <div :style="{ flex: 1 }">
        <div class="info-title">마감기간 지정</div>
        <div class="info-content">{{ this.endDate }}</div>
      </div>  
    </div>
    <div class="option-row">
      <div :style="{ flex: 1 }">
        <div class="info-title">설문 대상</div>
        <div class="info-content">{{ this.target }}</div>
      </div>
      <div :style="{ flex: 1 }">
        <div class="info-title">영어설문 여부</div>
        <div class="info-content">{{ this.targetEng }}</div>
      </div>
      <div :style="{ flex: 1 }">
        <div class="info-title">대학(원)생 할인</div>
        <div class="info-content">{{ this.identity }}</div>
      </div>
    </div>

    <OrderCalculatorModal v-model="orderModalOpen" />
  </div>
</template>

<script>
import store from '@/store';
import OrderCalculatorModal from '@/components/OrderCalculatorModal.vue'
export default {
  components: {
    OrderCalculatorModal
  },
  data(){
    return{
      headCount : '',
      spendTime : '',
      endDate : '',
      target : '',
      targetEng : '',
      identity : '',
      orderModalOpen : false

    }
  },

  mounted(){
    this.getOptions()
  },

  watch: {
    // 모달에서 옵션을 고쳐 저장하고 닫으면(같은 페이지라 라우팅이 안 바뀔 수
    // 있음) 카드에 표시된 값도 새로 읽어온다
    orderModalOpen(open) {
      if (!open) this.getOptions()
    }
  },

  methods : {
    getOptions(){
      const info = store.state.surveyOption
      const table = store.state.tables
      this.headCount = table.priceTextTable[0][store.state.maps.headCountMap[info.headCount]]
      this.spendTime = table.priceTextTable[1][store.state.maps.spendTimeMap[info.spendTime]]
      this.endDate = info.endDate + " " + info.endTime
      this.target = table.targetingTable[1][store.state.maps.targetGenderMap[info.targetGender]]+", "+ this.getAgeTarget()
      this.targetEng = table.priceTextTable[3][info.targetEng]
      this.identity = table.priceTextTable[4][store.state.maps.identityMap[info.identity]]
    },

    getAgeTarget(){
      let age = ""
      const info = store.state.surveyOption
      const table = store.state.tables
      for(let i in info.targetAge){
        age += table.targetingTable[2][store.state.maps.targetAgeMap[info.targetAge[i]]+1] + " "
      }
      

      return age
    }
  }

}
</script>

<style scoped>
.option-info-container{
  display: flex;
  flex-direction: column;
  font-family: var(--font-sans);
  text-align: left;
  max-width: 552px;
  margin: 24px auto;
  padding: 24px;
  box-sizing: border-box;
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
}
.option-row{
  display: flex;
  margin-top: 20px;
}
.option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-title{
  text-align: left;
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  color: var(--ink-900);
}
.option-edit-btn {
  padding: 6px 12px;
  border: 1px solid var(--ink-200);
  border-radius: var(--radius-sm);
  background-color: var(--white);
  color: var(--text-body);
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}
.option-edit-btn:hover {
  border-color: var(--ink-400);
}
.option-border{
  border-top: 1px solid var(--ink-200);
  margin-top: 14px;
}
.info-title{
  text-align: left;
  margin-right: 24px;
  color: var(--ink-500);
  font-size: 13px;
  font-weight: var(--font-weight-medium);
}
.info-content{
  text-align: left;
  margin-right: 24px;
  margin-top: 8px;
  font-size: 15px;
  color: var(--green-600);
  font-weight: var(--font-weight-semibold);
}
</style>